import React from 'react'
import { Text, Select } from '@usap/uicomponents'

const QuantitySelection = props => {
  const {
    eligibleRMA,
    partNumber,
    setQtyRange,
    handleQtyChange,
    ikey,
    qtyRange,
    qtyToCompute,
  } = { ...props }

  return (
    <Text
      size="small"
      color="#333333"
      style={{ fontWeight: 400, marginTop: 7, marginBottom: 7 }}
    >
      Qty:
      {' '}
      <Select
        id={eligibleRMA ? `qty-${partNumber}`: `qty-${partNumber}${ikey}`}
        style={{ width: '40px' }}
        options={setQtyRange(qtyRange)}
        value={qtyToCompute}
        justify="start"
        onChange={({ option }) => handleQtyChange(option)}
        disabled={!eligibleRMA}
      />
    </Text>
  )
}

export default QuantitySelection
